import React from "react";


import { ftchPlus, postOptions } from "./Account_urls.jsx";
import { API_tokenSignOut } from "./api.jsx";


export const signOut = () => {
  var url = API_tokenSignOut;
  var req = postOptions;
  ftchPlus(url, req)
    .then((response) => {

    })
    .catch((error) => {
      console.log(error);
    });
}

